<app-page-list [canInsert]="false" [canSearch]="true" [filterForm]="filterForm" [columns]="columns"
[queryService]="elaborazioneService.query" [crud]="elaborazioneService" [insertForm]="insertForm"
insertFormTitle="elaborazioni" insertFormSize="full" [visibleColumns]="visibleColumns">
<div filters>
    <app-filters-form [form]="filters"></app-filters-form>
</div>
</app-page-list>